import React, { Component } from 'react'
import { Alert } from 'react-bootstrap';
import { Row, Card, Col, Jumbotron, Container, Table, Button } from 'react-bootstrap';
import { CSVLink } from "react-csv";
import Menu from '../../menu';
import Spinner from '../../subcomponent/spinner';
import funciones from '../../../middleware/funciones';
import config from '../../../config';

export class clientes extends Component {
    constructor(props) {
        super(props)
        const currentCompany = sessionStorage.getItem('company');
        this.uploadTxtFile = this.uploadTxtFile.bind(this);
        //this.uploadCsvFile = this.uploadCsvFile.bind(this);
        this.state = {
            csvData: [],
            txtData: [],
            listErrores: [],
            empresa: currentCompany,
            loadingText: false,
            mensajeProcess: "",
            estadoProcess: false,
            tipoAlert: "",
            infobase:[[]]
        }
    }

    componentDidMount=()=>{
        const info = [[
            "ID_EMPRESA"
            ,"TIPO_IDENTIFICACION"
            ,"DOCUMENTO_CLIENTE"
            ,"DV_CLIENTE"
            ,"NOMBRE_CLIENTE"
            ,"DIRECCION_CLIENTE"
            ,"CODIGO_POSTAL"
            ,"CODIGO_DEPARTAMENTO_CLIENTE"
            ,"NOMBRE_DEPARTAMENTO_CLIENTE"
            ,"CODIGO_CIUDAD_CLIENTE"
            ,"NOMBRE_CIUDAD_CLIENTE"
            ,"TELEFONO_FIJO_CLIENTE"
            ,"EMAIL_CLIENTE"
            ,"TIPO_TERCERO"
            ,"NOMBRE_ESTABLECIMIENTO"
            ,"BARRIO_CLIENTE"
            ,"TELEFONO_CELULAR_CLIENTE"
            ,"CIIU"
            ,"ESTADO_CLIENTE"
            ,"CONTACTO_COMPRA"
            ,"GRAN_CONTRIBUYENTE"
            ,"LIQUIDA_IVA"
            ,"LIQUIDA_RENTA"
            ,"LIQUIDA_RETEIVA"
            ,"LIQUIDA_RETEICA"
            ,"LIQUIDA_RETEOTROS"
            ,"OBSERVACIONES_CLIENTE"
            ,"RESPONSABILIDAD"
            ,"REGIMEN"
        ],[
            "111111111"
            ,"31 NIT / 13 CEDULA"
            ,"999999999"
            ,"0"
            ,"CLIENTE DE PRUEBA"
            ,"CALLE 1 CARRERA 1"
            ,"1234"
            ,"76"
            ,"VALLE DEL CAUCA"
            ,"76001"
            ,"CALI"
            ,"3701197"
            ,"XXXXXXX@GMAIL.COM"
            ,"1 PERSONAN NATURAL/ 2 PERSONA JURIDICA"
            ,"NINGUNO"
            ,"CALIMA"
            ,"3152935043"
            ,"1234"
            ,"1 ACTIVO / 0 INACTIVO"
            ,"CONTACTO DE PRUEBA"
            ,"1 ACTIVO / 0 INACTIVO"
            ,"1 ACTIVO / 0 INACTIVO"
            ,"1 ACTIVO / 0 INACTIVO"
            ,"1 ACTIVO / 0 INACTIVO"
            ,"1 ACTIVO / 0 INACTIVO"
            ,"1 ACTIVO / 0 INACTIVO"
            ,"OBSERVACION CLIENTE"
            ,"R-99-PN"
            ,"48"

        ],[
            "111111111"
            ,"13"
            ,"999999999"
            ,"0"
            ,"CLIENTE DE PRUEBA"
            ,"CALLE 1 CARRERA 1"
            ,"1234"
            ,"76"
            ,"VALLE DEL CAUCA"
            ,"76001"
            ,"CALI"
            ,"3701197"
            ,"XXXXXXX@GMAIL.COM"
            ,"2"
            ,"NINGUNO"
            ,"CALIMA"
            ,"3152935043"
            ,"1234"
            ,"1"
            ,"CONTACTO DE PRUEBA"
            ,"1"
            ,"1"
            ,"1"
            ,"1"
            ,"1"
            ,"1"
            ,"OBSERVACION CLIENTE"
            ,"R-99-PN"
            ,"48"

        ]]
        this.setState({infobase: info});
    }

    uploadTxtFile(event) {
        this.setState({ loadingText: true });
        const listErrores = [];
        const fileReader = new FileReader();
        const file = event.target.files[0];

        const callback = (lines) => {
            const cabecera = "ID_EMPRESA,TIPO_IDENTIFICACION,DOCUMENTO_CLIENTE,DV_CLIENTE,NOMBRE_CLIENTE,DIRECCION_CLIENTE,CODIGO_POSTAL,CODIGO_DEPARTAMENTO_CLIENTE,NOMBRE_DEPARTAMENTO_CLIENTE,CODIGO_CIUDAD_CLIENTE,NOMBRE_CIUDAD_CLIENTE,TELEFONO_FIJO_CLIENTE,EMAIL_CLIENTE,TIPO_TERCERO,NOMBRE_ESTABLECIMIENTO,BARRIO_CLIENTE,TELEFONO_CELULAR_CLIENTE,CIIU,ESTADO_CLIENTE,CONTACTO_COMPRA,GRAN_CONTRIBUYENTE,LIQUIDA_IVA,LIQUIDA_RENTA,LIQUIDA_RETEIVA,LIQUIDA_RETEICA,LIQUIDA_RETEOTROS,OBSERVACIONES_CLIENTE,RESPONSABILIDAD,REGIMEN";
            const arrayCabeceraBase = cabecera.split(",");
            const cabeceraFile = funciones.limpiezaCaracter(lines[0], ["\r", "\"", " "]);
            const arrayCabeceraFile = cabeceraFile.split(";")
            let infoClientes = [];

            if (JSON.stringify(arrayCabeceraBase) === JSON.stringify(arrayCabeceraFile.slice(0, arrayCabeceraBase.length))) {
                this.setState({
                    mensajeProcess: "Cabeceras procesadas correctamente",
                    estadoProcess: true,
                    tipoAlert: "success"
                });
                for (let index = 1; index < lines.length - 1; index++) {
                    const element = lines[index];
                    const data = funciones.limpiezaCaracter(element, ["\r", "\""]);
                    const arrayData = data.split(";");
                    ////console.log(arrayCabeceraBase.length);
                    if (element.length > 0) {
                        infoClientes.push(arrayData.slice(0, arrayCabeceraBase.length));
                    } else {
                        const men = "Error en los datos de la fila " + (index + 1);
                        this.setState({
                            mensajeProcess: men,
                            estadoProcess: true,
                            tipoAlert: "danger"
                        });
                    }
                }
            } else {
                this.setState({
                    mensajeProcess: "Error en la estructura, DESCARGUE EL ARCHIVO BASE",
                    estadoProcess: true,
                    tipoAlert: "danger"
                });
            }

            if (infoClientes.length > 0) {
                const datasend = {
                    method: 'POST',
                    body: JSON.stringify({
                        infoClientes,
                        arrayCabeceraBase
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        'empresa': this.state.empresa
                    }
                }

                fetch(config.servBackEnd + '/cargadata/cargaclientes', datasend)
                    .then(res => res.json())
                    .then((data) => {
                        //console.log(data);
                        data.forEach(element => {
                            if (!element.ok) {
                                listErrores.push(element);
                            }
                        });
                        const mensaje = (listErrores.length > 0) ? "Clientes actualizados correctamente con advertencias" : "Clientes actualizados correctamente";
                        const tipo = (listErrores.length > 0) ? "warning" : "success";
                        this.setState({
                            loadingText: false,
                            mensajeProcess: mensaje,
                            estadoProcess: true,
                            tipoAlert: tipo,
                            listErrores
                        });
                    })
                    .catch((error) => console.error(error))
            } else {
                this.setState({ loadingText: false });
            }
        }


        fileReader.readAsText(file);
        fileReader.onloadend = function () {
            const lines = this.result.split('\n');
            callback(lines);
        }


    }
    render() {
        const { loadingText, estadoProcess, mensajeProcess, tipoAlert, listErrores, infobase } = this.state;
        return (
            <div>
                <Menu></Menu>
                <Jumbotron className="Jumbotron">
                    <h2>Carga Masiva Clientes</h2>
                </Jumbotron>
                <Container >
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Row className="justify-content-md-center" >
                                        <h4>Descargar archivo base</h4>
                                        <Col className="mb-2">
                                            <CSVLink data={infobase} filename={"carga_clientes.csv"} separator={";"}>
                                                <Button variant="success">Descargar</Button>
                                            </CSVLink>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {(!loadingText) && <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Row className="justify-content-md-center" >
                                        <h4>Carga archivo de terceros</h4>
                                        <Col className="mb-2">
                                            <input type="file" name="myFile" accept=".csv" onChange={this.uploadTxtFile} className="btn btn-primary" />
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>}
                    {estadoProcess && <Row className="justify-content-md-center" ><Alert variant={tipoAlert}>{mensajeProcess}</Alert></Row>}
                    {listErrores.length > 0 && <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>No Linea</th>
                                <th>Mensaje de error</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listErrores.map((data, i) => {
                                    return (<tr key={i}>
                                        <td>{data.linea}</td>
                                        <td>{data.msg}</td>
                                    </tr>)
                                })
                            }
                        </tbody>
                    </Table>
                    }
                    {(loadingText) && <Row>
                        <Col className="mb-2">
                            <Spinner loading={loadingText} />
                        </Col>
                    </Row>}
                </Container>
            </div>
        )
    }
}

export default clientes
